export const CloseIcon = <svg
  width="16"
  height="16"
  viewBox="0 0 16 16"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M16 2.23999L13.76 0L7.99998 5.76L2.23999 0L0 2.23999L5.76 7.99998L0 13.76L2.23999 16L7.99998 10.24L13.76 16L16 13.76L10.24 7.99998L16 2.23999Z"
    fill="#70818A" />
</svg>;

export const BackIcon = <svg
  width="13"
  height="20"
  viewBox="0 0 13 20"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M12.2002 16.5119L5.25895 9.57062L12.2002 2.62938L9.57082 -1.14934e-07L0.000194738 9.57062L9.57081 19.1412L12.2002 16.5119Z"
    fill="#70818A" />
</svg>;

export const ScheduleSuperhero = <svg
  width="71"
  height="73"
  viewBox="0 0 71 73"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <g clip-path="url(#clip0_403_375)">
    <path
      d="M70.0447 55.4839C61.1646 57.0883 58.732 48.0974 55.0277 44.0085C52.2697 40.9622 48.3953 38.4557 49.3122 34.0194C50.1107 30.1376 50.022 26.2706 50.0663 22.1004C50.0885 20.1114 48.0404 17.9228 46.2289 18.2999C43.3823 18.8914 40.5208 19.2833 37.6076 19.3573C35.6556 19.409 33.5558 19.0763 31.6777 19.7417C29.3708 20.5551 29.149 27.0026 24.6165 31.8086C22.1174 34.463 17.1265 36.2819 14.2577 38.5223C9.08935 42.5519 4.28331 47.3358 0.956055 53.7093C5.71033 54.2713 9.09674 54.4044 11.7733 58.7002C13.0894 60.8075 15.6256 62.4785 17.9694 63.2992C21.1192 64.4009 23.8106 63.8242 26.99 63.2401C29.844 62.7151 31.2563 63.1809 33.5632 64.8446C34.7166 65.6727 36.0327 66.4564 37.371 66.9444C40.1659 67.9574 42.9091 67.4028 45.6226 66.3825C49.8963 64.778 53.1644 63.7429 57.8226 64.1421C63.9669 64.6671 69.2535 59.6245 70.0373 55.4913L70.0447 55.4839Z"
      fill="url(#paint0_linear_403_375)" />
    <path
      d="M67.5163 18.8397C66.4516 17.4201 63.8342 17.1539 63.1022 18.263C62.836 18.6696 63.6715 22.2409 62.3036 22.4701C57.8895 23.2095 55.9227 24.8879 55.9227 24.8879C55.9227 24.8879 55.309 20.2519 52.8099 18.958C52.1592 16.1187 51.0131 15.7638 50.3994 15.2315C49.6305 14.566 47.0574 13.8118 44.8097 13.2499C44.7875 12.9763 44.7727 12.6658 44.7727 12.3331C46.0296 11.7342 47.1239 10.1888 47.331 9.53816C47.782 8.14811 47.7672 4.96873 48.063 3.95577C49.5122 3.82268 50.0667 2.38826 50.0667 2.38826C50.0667 2.38826 48.4031 2.73577 47.989 2.38826C48.8024 2.01117 49.2312 0.968631 49.2312 0.968631C49.2312 0.968631 47.8116 1.27178 46.6212 0.828147C46.2441 0.621118 45.7413 0.399301 45.0389 0.184877C42.5102 -0.584088 39.0202 1.30875 39.0202 1.30875V4.07407C39.0202 4.07407 39.0498 4.47334 39.0868 5.07225C38.8132 4.94655 38.4213 4.8874 38.1773 5.39758C37.7781 6.23309 38.4065 7.75623 39.3677 7.95587C39.3973 8.19247 39.4343 8.42908 39.4713 8.6435C39.5082 9.2498 39.5082 10.1666 39.2716 10.9948C39.1164 11.5123 38.865 12.0299 38.6284 12.4514C38.5914 12.4514 38.5544 12.4514 38.5101 12.4588C36.8242 12.6214 34.8501 13.3386 33.1938 14.3146C29.8 16.311 29.9923 18.0633 28.4543 19.3055C25.4894 21.6937 24.7574 24.2964 24.7574 24.2964C24.7574 24.2964 19.0197 20.5181 18.65 19.2538C18.2877 17.9894 20.4024 15.4311 18.8053 14.4699C17.0456 13.42 14.2433 14.8987 14.2876 17.1243C14.3246 18.921 15.7886 20.7621 16.5206 22.2113C17.4152 23.9785 20.395 26.6329 22.3544 28.7106C23.9736 30.4259 24.7056 30.0193 25.4968 29.7013C27.0717 29.0729 31.6485 26.5441 33.8001 22.8472C33.7262 24.6217 34.8501 26.3001 34.7244 28.3926C34.6209 30.1819 34.3621 31.9713 34.1181 33.3909H33.8297C33.8297 33.3909 31.2345 37.1766 30.3768 41.3911C29.3712 46.3228 31.7668 49.0955 30.6577 50.4486C29.4303 51.9496 25.4894 56.556 24.4764 62.7077C24.2472 64.083 22.4209 69.7911 22.347 71.7652C22.2878 73.4289 25.8369 72.9261 27.3379 72.9557C30.2067 73.0148 26.177 66.1828 27.8037 64.1865C29.7852 61.7465 34.7392 55.5948 36.2253 52.9404C37.7189 50.286 41.024 43.5205 41.024 43.5205C41.024 43.5205 48.1517 48.6667 53.7045 50.7C54.3774 50.9514 52.4697 55.6835 54.7545 62.9591C56.1889 67.5433 52.6398 68.7485 54.2443 70.353C54.821 70.9297 55.9375 70.5822 57.4458 71.2772C61.2019 73.0074 62.2888 72.9557 64.1003 72.512C65.6013 72.1423 66.4516 70.7892 65.0837 70.0277C61.8008 68.194 58.7767 67.669 58.9616 66.3233C59.457 62.7299 61.1206 54.885 59.9893 50.5817C59.3756 48.2379 60.8692 47.1657 57.8821 44.6888C53.9559 41.4355 47.2053 34.4926 46.6064 33.8715C46.8356 32.0674 47.2349 30.6773 47.7672 29.7457C49.3939 26.9212 49.4752 23.6605 49.4752 23.6605C49.4752 23.6605 50.1333 25.7974 51.4937 27.4166C52.662 28.8141 53.2091 29.8788 54.5696 29.8788C55.7822 29.8788 57.786 29.7753 60.2407 27.9046C63.1022 25.7234 64.5662 24.1189 66.0819 22.9581C67.8343 21.605 68.0413 19.5421 67.5311 18.8545L67.5163 18.8397Z"
      fill="#003750" />
    <path
      d="M44.8018 13.2425C44.8018 13.2425 44.7722 15.4902 46.3471 15.9339C47.922 16.3775 49.2381 15.4015 49.3121 14.6251C49.3417 14.3294 49.0311 13.4125 47.3675 13.0059C45.7039 12.5992 44.8092 13.2425 44.8092 13.2425H44.8018Z"
      fill="url(#paint1_linear_403_375)" />
    <path
      d="M33.792 13.8636C33.792 13.8636 35.0046 13.7157 36.025 14.9801C37.0453 16.2444 38.3318 16.6437 39.1969 16.0004C40.062 15.3572 40.343 13.2795 38.7237 12.5771C37.1119 11.8672 34.4796 12.3774 33.792 13.871V13.8636Z"
      fill="url(#paint2_linear_403_375)" />
    <path
      d="M33.2822 34.2486C33.2822 34.2486 37.6742 35.4686 41.3268 35.4686C44.9794 35.4686 47.3454 34.6183 47.3454 34.6183L46.9462 32.2226C46.9462 32.2226 44.7871 32.4518 41.593 32.4518C38.8277 32.4518 34.4505 31.0396 34.4505 31.0396L33.2822 34.2486Z"
      fill="white" />
  </g>
  <defs>
    <linearGradient
      id="paint0_linear_403_375"
      x1="0.956055"
      y1="67.5151"
      x2="67.5273"
      y2="15.0297"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="#269BE9" />
      <stop offset="1" stop-color="#6CD1F1" />
    </linearGradient>
    <linearGradient
      id="paint1_linear_403_375"
      x1="44.8018"
      y1="16.0472"
      x2="49.1068"
      y2="12.6094"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="#269BE9" />
      <stop offset="1" stop-color="#6CD1F1" />
    </linearGradient>
    <linearGradient
      id="paint2_linear_403_375"
      x1="33.792"
      y1="16.3063"
      x2="39.3384"
      y2="11.6038"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="#269BE9" />
      <stop offset="1" stop-color="#6CD1F1" />
    </linearGradient>
    <clipPath id="clip0_403_375">
      <rect
        width="69.0886"
        height="73"
        fill="white"
        transform="translate(0.956055)" />
    </clipPath>
  </defs>
</svg>;

export const TasksSuperhero = <svg
  width="41"
  height="73"
  viewBox="0 0 41 73"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <g clip-path="url(#clip0_403_368)">
    <path
      d="M30.8571 55.8566C29.0011 51.196 26.1673 36.7108 25.0256 31.9214C24.3932 29.2691 25.1134 20.873 23.6848 15.5977C23.6145 15.3459 9.06488 14.8658 9.17027 19.0111C7.02149 27.1261 7.39035 34.9133 7.81777 43.3093C8.04025 47.7357 9.1527 51.4946 9.94898 55.8566C10.4408 58.5616 9.35763 62.8826 11.8343 64.5571C14.5627 66.4073 17.3204 63.6086 21.4306 64.4049C23.1637 64.7444 24.3288 66.7176 25.898 67.2855C27.0455 67.7012 28.0819 67.3558 29.1475 66.9049C29.8208 66.6239 30.4707 66.0442 31.2143 66.056C31.9579 66.0677 32.8069 67.6485 34.5458 67.9003C39.3293 68.5853 39.9851 63.7432 40.5237 60.8274C34.2823 63.9716 31.8057 58.222 30.863 55.8507L30.8571 55.8566Z"
      fill="url(#paint0_linear_403_368)" />
    <path
      d="M11.3016 20.5803C11.3016 20.5803 9.75006 27.5887 8.16921 31.1193C7.42563 32.7821 6.82257 39.8666 6.54738 44.779C6.40101 47.3552 7.2734 50.634 6.74645 53.9479C6.07313 58.1928 7.98185 63.2983 6.74645 67.2504C6.55324 67.8652 5.65742 68.884 3.90093 69.6627C2.39034 70.336 0.569439 70.8395 0.487469 71.6124C0.311819 73.2811 4.76747 71.9988 6.61764 71.952C8.20434 71.911 9.65638 72.7658 10.1482 71.7119C10.8332 70.2482 9.92571 68.925 10.0487 67.2212C10.1658 65.652 12.9059 59.9024 12.4551 54.4397C12.4082 53.8835 11.5593 50.4642 11.6822 50.0192C12.2267 48.0753 13.0464 46.1315 13.4387 44.2169C14.0535 41.2016 14.6331 36.9684 14.6331 36.9684C14.6331 36.9684 15.1835 44.6326 15.8451 46.0437C16.5126 47.4547 17.8358 50.1304 17.9529 51.442C18.1637 53.8015 18.4857 57.3262 19.2234 59.6565C20.693 64.2819 22.3617 66.097 22.2329 67.8125C22.1217 69.247 21.6064 70.8747 21.8523 71.6592C22.3149 73.1405 23.8723 72.9708 24.7271 72.9883C26.0972 73.0176 27.356 72.7307 26.1967 69.3172C24.5573 64.4869 24.1299 60.4996 23.7552 55.9971C23.4507 52.3436 22.2563 49.2932 22.3149 48.7662C22.4905 47.2147 22.5139 37.794 21.9987 34.8138C21.097 29.6497 19.323 25.1589 19.323 25.1589C19.323 25.1589 18.152 17.5826 11.3016 20.5745V20.5803Z"
      fill="#003750" />
    <path
      d="M9.36914 27.8522C9.36914 27.8522 11.0671 29.1871 14.0766 29.4389C17.8355 29.7551 20.4936 28.5665 20.4936 28.5665L20.0252 26.9037C20.0252 26.9037 16.7347 27.8346 14.3927 27.536C11.9336 27.2257 9.87852 26.1718 9.87852 26.1718L9.375 27.8522H9.36914Z"
      fill="white" />
    <path
      d="M25.0139 14.9126C24.7328 13.1151 23.0407 12.5121 22.0571 12.2193C20.3826 11.7217 19.3404 11.5519 18.6671 10.8258C18.4504 10.5917 18.2045 9.57874 18.0406 8.79417C18.0406 8.78831 18.0523 8.7766 18.0581 8.77075C18.3685 8.25551 18.6495 7.73442 18.8603 7.17234C19.0184 7.22503 19.2584 7.24845 19.3931 7.01425C19.6097 6.64539 20.1776 5.81983 19.8556 5.35144C19.6975 5.12309 19.516 5.11138 19.3579 5.15822C19.3638 4.87133 19.3814 4.29168 19.3989 3.44856C19.4341 2.17218 19.5629 1.51642 19.7151 0.983614C19.4575 1.10071 19.2408 1.31735 19.2408 1.31735C19.2408 1.31735 19.1003 0.848949 18.749 0.632315C18.4036 0.41568 15.8215 -0.538683 14.1821 0.4391C12.5369 1.41688 11.3015 1.58082 11.3015 1.58082C11.3015 1.58082 11.8226 1.89114 12.0685 1.97311C11.8109 2.04337 11.3015 2.01409 11.3015 2.01409C11.3015 2.01409 11.5298 2.44151 12.2032 2.50006C12.0334 2.97431 12.1387 4.16873 12.2266 4.9533C12.1036 4.94159 11.9631 4.98257 11.8343 5.15237C11.4888 5.6032 12.0099 6.45217 12.209 6.8386C12.332 7.07866 12.572 7.06695 12.736 7.02011C12.9175 7.5939 13.1692 8.1267 13.4561 8.6595C13.4737 8.68878 13.4971 8.72391 13.5147 8.75318C13.4093 9.245 13.2278 9.97102 13.0638 10.2345C12.4608 11.2181 11.6528 11.5753 9.9724 11.8563C8.67845 12.0788 7.70652 12.5882 6.58236 14.4091C5.62214 15.9607 5.54603 18.6598 5.30597 19.3156C4.28135 22.1435 4.96638 25.8966 6.13738 25.8907C6.47697 25.8907 9.6738 25.1354 12.5545 24.4855C14.3754 25.6682 17.6132 27.413 18.4036 27.817C19.5395 28.4025 23.3803 21.9093 23.9658 20.2992C24.5513 18.6891 25.1193 15.6445 25.008 14.9243L25.0139 14.9126Z"
      fill="#003750" />
    <path
      d="M18.404 10.2345C18.404 10.2345 16.6006 12.8283 18.1698 13.121C19.7389 13.4138 22.0633 12.2252 22.0633 12.2252C22.0633 12.2252 21.0563 11.2181 20.5469 11.0015C20.0375 10.7849 19.3349 10.8551 19.3349 10.8551C19.3349 10.8551 19.13 10.2111 18.4098 10.2404L18.404 10.2345Z"
      fill="url(#paint1_linear_403_368)" />
    <path
      d="M13.2393 9.83051C13.2393 9.83051 13.4091 11.142 13.0695 11.9442C12.8704 12.4184 12.4254 12.8927 11.7228 12.4184C11.0202 11.9442 10.2122 11.8153 10.2122 11.8153C10.2122 11.8153 9.98975 11.3938 10.5108 10.8493C11.1666 10.1525 11.9746 10.4101 11.9746 10.4101C11.9746 10.4101 12.6362 9.83636 13.2393 9.83051Z"
      fill="url(#paint2_linear_403_368)" />
  </g>
  <defs>
    <linearGradient
      id="paint0_linear_403_368"
      x1="7.49023"
      y1="68.0023"
      x2="53.3787"
      y2="51.7919"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="#269BE9" />
      <stop offset="1" stop-color="#6CD1F1" />
    </linearGradient>
    <linearGradient
      id="paint1_linear_403_368"
      x1="17.5283"
      y1="13.1694"
      x2="21.5673"
      y2="9.66133"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="#269BE9" />
      <stop offset="1" stop-color="#6CD1F1" />
    </linearGradient>
    <linearGradient
      id="paint2_linear_403_368"
      x1="10.165"
      y1="12.6168"
      x2="13.6551"
      y2="10.4224"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="#269BE9" />
      <stop offset="1" stop-color="#6CD1F1" />
    </linearGradient>
    <clipPath id="clip0_403_368">
      <rect
        width="40.0364"
        height="73"
        fill="white"
        transform="translate(0.481445)" />
    </clipPath>
  </defs>
</svg>;

export const CampaignsSuperhero = <svg
  width="83"
  height="73"
  viewBox="0 0 83 73"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <g clip-path="url(#clip0_403_364)">
    <path
      d="M81.8476 0.515248C80.8628 -0.637348 78.5334 0.427108 77.1207 0.861027C75.7081 1.29495 70.2953 5.66803 67.8844 7.72236C65.8673 9.44448 61.3034 11.4649 58.811 12.5768C58.7567 12.2853 58.7431 12.0548 58.7499 11.9192C58.7906 11.2818 60.2644 10.9971 60.828 10.7123C62.0437 10.1021 60.7058 9.1665 61.0046 8.71224C61.2016 8.41392 60.9231 8.41392 60.7465 8.33256C60.7194 8.20374 60.8824 8.00034 60.862 7.88508C60.8077 7.6071 60.5224 7.71558 60.4749 7.58676C60.3526 7.2681 61.0725 6.69181 60.7873 6.46807C60.2983 6.08161 58.7363 5.81719 58.614 5.41039C58.356 4.59679 57.9892 4.12219 57.378 3.65438C57.3101 3.60014 57.2422 3.55946 57.181 3.512C56.8822 1.04409 54.4373 1.81022 52.9296 2.82044C50.247 4.61713 50.3217 6.33247 50.3217 6.33247C50.3217 6.33247 49.7104 7.92576 51.6664 10.1903C52.6511 11.3293 52.5696 11.37 53.9958 12.8006C54.0434 12.8887 54.0773 12.9836 54.1181 13.0718C50.8514 14.2176 49.2962 18.8076 49.2894 22.6926C49.2894 25.9876 47.218 30.1098 45.5133 32.9642C43.863 33.5066 41.5675 34.3541 40.053 35.3372C36.9493 37.3576 35.6725 41.5002 33.9746 44.0834C32.5688 46.2258 30.9592 50.5922 29.8658 50.9854C28.7724 51.3854 25.2476 52.4838 22.4428 56.3484C19.3594 60.5926 15.4611 63.1148 13.7157 63.2165C12.079 63.3114 11.4542 63.5487 10.9041 65.6166C10.354 67.6845 9.2198 69.1151 8.28937 71.1762C7.35894 73.2305 8.17391 73.7797 11.0331 71.4609C12.1469 70.5592 14.4017 68.4642 18.4358 65.4606C24.7586 60.7553 32.9831 55.6568 34.7353 53.833C39.8628 48.5107 52.8005 36.7339 52.8005 36.7339C55.5171 34.2524 58.6412 30.9438 60.6039 27.3843C62.3833 24.157 62.4105 21.1942 61.8739 18.8754C63.273 17.4855 64.6788 16.1228 65.7383 15.1803C67.9794 13.2074 71.2597 11.8107 73.6299 9.19362C76.0069 6.57655 77.732 4.54933 77.732 4.54933C77.732 4.54933 80.727 5.20021 81.6846 4.40017C82.6354 3.60014 82.8391 1.6475 81.8544 0.494908L81.8476 0.515248Z"
      fill="#003750" />
    <path
      d="M44.8486 33.2083L50.0441 39.2832L52.8014 36.761L46.1594 31.8727L44.8486 33.2083Z"
      fill="white" />
    <path
      d="M57.6159 13.1261C57.6159 13.1261 52.502 15.9601 50.5189 19.2958C46.7428 25.6554 39.8427 32.3676 35.8969 35.0864C23.1493 43.8597 19.2238 42.7613 13.1047 50.1583C9.97389 53.9483 9.68865 60.4774 9.68865 60.4774C9.68865 60.4774 -1.94511 57.4874 0.975213 49.2633C3.88875 41.0392 15.2441 34.7881 20.4124 33.3439C25.5806 31.8998 34.5589 26.1843 40.3385 18.8755C45.2283 12.6921 51.7481 10.9293 57.6227 13.1261H57.6159Z"
      fill="url(#paint0_linear_403_364)" />
  </g>
  <defs>
    <linearGradient
      id="paint0_linear_403_364"
      x1="0.504883"
      y1="60.5109"
      x2="62.3932"
      y2="19.3628"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="#269BE9" />
      <stop offset="1" stop-color="#6CD1F1" />
    </linearGradient>
    <clipPath id="clip0_403_364">
      <rect
        width="82"
        height="73"
        fill="white"
        transform="translate(0.5)" />
    </clipPath>
  </defs>
</svg>;